export default "__VITE_ASSET__DqQKoo9l__"